module.exports = __webpack_public_path__ + "media/images/logo-revert-0e6bd2560e8681981e576ffd398b5e40.svg";